import { Card } from "@/components/ui/card";
import { CalendarClock, ArrowRight, AlertTriangle } from "lucide-react";

const fmtTanggal = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : (iso || "-");
};

export default function PensiunReminderCard({ reminders, onNavigate }) {
  if (!reminders?.length) return null;
  return (
    <Card className="p-6 border-amber-200 bg-amber-50/40 shadow-none rounded-lg" data-testid="pensiun-reminder-card">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => onNavigate?.("pekerja")} data-testid="goto-pekerja-pensiun"
          className="flex items-center gap-2 group" title="Buka Data Pekerja">
          <CalendarClock className="h-4 w-4 text-amber-600" />
          <h3 className="text-base font-semibold text-slate-900 group-hover:text-amber-700 transition-colors">
            Pengingat Pensiun (Usia {reminders[0].usia_pensiun} Tahun)
          </h3>
          <ArrowRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-amber-700 group-hover:translate-x-0.5 transition-all" />
        </button>
        <span className="text-xs text-amber-700 font-semibold ml-auto">3 bulan ke depan</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="pensiun-reminder-list">
        {reminders.map((r, i) => (
          <div key={r.nomor_pegawai || i} data-testid={`pensiun-reminder-item-${i}`}
            className={`rounded-lg border p-3 flex items-center gap-3 ${
              r.sisa_hari <= 30 ? "border-amber-300 bg-amber-100/60" : "border-amber-100 bg-white"
            }`}>
            <div className={`h-10 w-12 rounded-lg flex flex-col items-center justify-center shrink-0 ${
              r.sisa_hari <= 30 ? "bg-amber-500 text-white" : "bg-amber-50 border border-amber-200 text-amber-700"
            }`}>
              <span className="text-sm font-bold leading-none">{r.sisa_hari}</span>
              <span className="text-[9px] leading-tight">hari</span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-slate-900 truncate">{r.nama}</p>
              <p className="text-xs text-slate-500 truncate">
                {r.jabatan}{r.lokasi_kerja ? ` · ${r.lokasi_kerja}` : ""}
              </p>
              <p className="text-[11px] text-amber-700 font-medium">
                Usia {r.usia_pensiun} pada {fmtTanggal(r.tanggal_pensiun)}
              </p>
            </div>
            {r.hari_ini && (
              <span className="flex items-center gap-1 text-[11px] font-bold text-amber-700 shrink-0">
                <AlertTriangle className="h-3.5 w-3.5" /> Hari Ini
              </span>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}
